import React from 'react';
import { makeStyles } from '@fluentui/react-components';
import AppMeasurement from './content/page';
import { AppHeader } from './content/header';
import AppContentDrawer from './content/contentDrawer';
import { useAppActions, useAppState } from './context';

const useStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
    justifyContent: 'stretch',
    width: '100vw',
    height: '100vh',
  },

  content: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'stretch',
    alignItems: 'stretch',
    flexBasis: '10px',
    flexShrink: 0,
    flexGrow: 1,
    overflowY: 'hidden',
    position: 'relative',
  },
  contentOverlay: {
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.4)',
    zIndex: 1000,
  },

  measurement: {
    flexGrow: 1,
    flexBasis: 0,
    minWidth: 0,
    minHeight: 0,
  },
});
function App() {
  const styles = useStyles();
  const appState = useAppState();
  const appActions = useAppActions();

  const contentRef = React.useRef<HTMLDivElement>(null);

  return (
    <div className={styles.root}>
      <AppHeader />
      <div className={styles.content} ref={contentRef}>
        <AppContentDrawer mountNode={contentRef.current} />
        <AppMeasurement className={styles.measurement} />
        {appState.view.contentIsOpen && (
          <div className={styles.contentOverlay} onClick={() => appActions.view.closeContent()} />
        )}
      </div>
    </div>
  );
}

export default App;
